export default "__VITE_ASSET__DpLZdQux__"